const steps = [
  {
    number: '01',
    icon: 'ri-file-list-3-line',
    title: 'Apply to be featured',
    sub: 'Takes less than 2 minutes',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'We review for fit + alignment',
    sub: 'Response within 2–3 business days',
  },
  {
    number: '03',
    icon: 'ri-group-fill',
    title: 'Get in front of our community',
    sub: '3,000+ local moms, actively engaged',
  },
];

export default function HowItWorksStrip() {
  return (
    <section className="py-16 bg-gray-50 border-y border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-xs font-bold tracking-widest uppercase text-rose-500 mb-3 block">
            Simple Process
          </span>
          <h2
            className="text-2xl font-extrabold text-gray-900"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 relative">
          {/* Connector lines — desktop only */}
          <div className="hidden sm:block absolute top-9 left-[calc(16.67%+1.5rem)] right-[calc(16.67%+1.5rem)] h-px bg-gray-200" />

          {steps.map((step, i) => (
            <div key={step.number} className="relative flex flex-col items-center text-center">
              {/* Step circle */}
              <div className={`relative z-10 w-[72px] h-[72px] flex items-center justify-center rounded-full mb-4 ${
                i === 1 ? 'bg-rose-500' : 'bg-white border-2 border-gray-200'
              }`}>
                <i className={`${step.icon} text-2xl ${i === 1 ? 'text-white' : 'text-gray-600'}`} />
                <div className={`absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full text-[9px] font-black ${
                  i === 1 ? 'bg-white text-rose-500' : 'bg-gray-900 text-white'
                }`}>
                  {step.number}
                </div>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-1 leading-snug">{step.title}</h3>
              <p className="text-xs text-gray-400">{step.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
